import React, { memo, useState } from "react"

const ImageShow = ({
  imageData,
  key,
  alt,
  pictureclass,
  Children,
  imgTagClass,
  onClick,
}) => {
  const match = imageData
  const test2 = imageData?.split(".").pop()

  const [hasError, setHasError] = useState(false)

  const webpageImageShow = () => {
    if (test2 === "png" || test2 === "jpg" || test2 === "jpeg") {
      return match.replace(test2, "webp")
    } else {
      return match
    }
  }

  if (hasError) {
    return (
      <picture
        className={pictureclass}
        key={key}
        onClick={onClick}
        onKeyDown={onClick}
      >
        <img
          src={imageData}
          alt={alt}
          loading="lazy"
          width="100%"
          height="100%"
          onError={e => (e.target.src = `/images/placeholder-image.jpg`)}
        />
        {Children}
      </picture>
    )
  }
  return (
    <>
      <picture
        className={pictureclass}
        key={key}
        onClick={onClick}
        onKeyDown={onClick}
      >
        <source
          media=""
          // srcSet={imageData}
          srcSet={webpageImageShow()}
          // className={imgTagClass}
        />
        <source
          media=""
          srcSet={imageData}
          // className={imgTagClass}
        />
        <img
          src={imageData}
          width="100%"
          height="100%"
          alt={alt}
          loading="lazy"
          onError={setHasError(true)}
          // className={imgTagClass}
        />
        {Children}
      </picture>
    </>
  )
}

export default memo(ImageShow)
